var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dl',{staticClass:"accordion box",attrs:{"role":"presentation"}},_vm._l((_vm.content),function(item){return _c('accordionItem',{key:item.id,attrs:{"multiple":_vm.multiple,"item":item,"groupId":_vm.groupId}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }